import ls from '../../services/ls';

export default {
  data() {
    return {
      questionsSlider: null,
    };
  },
  computed: {
    isTestDone() {
      return this.answeredQuestions.length >= this.questions.length || this.timer <= 0;
    },
    currentQuestion() {
      return this.currentQuestionIndex !== null ? this.questions[this.currentQuestionIndex] : {};
    },
  },
  methods: {
    updateAppSettings() {
      this.$nextTick(() => {
        ls.updateAppSettings(this.$appSettings);
      });
    },
    initSly() {
      this.$nextTick(() => {
        /* eslint-disable no-undef */
        this.questionsSlider = new Sly(
          this.$refs['questions-slider'],
          {
            horizontal: 1,
            itemNav: 'centered',
            smart: 1,
            activateOn: false,
            mouseDragging: true,
            touchDragging: true,
            scrollTrap: 1,
            releaseSwing: 1,
            startAt: 0,
            scrollBy: 1,
            speed: 1,
            clickBar: 1,
            // scrollBar: $sly.parent().find('.scrollbar'),
            dragHandle: 1,
            dynamicHandle: 1,
           // next: $nextArrow,
          },
        ).init();
      });
    },
    initResultDropdowns() {
      this.$nextTick(() => {
        $('.js-wrong-btn').on('click', (event) => {
          const button = $(event.target);

          if (button.attr('data-open') === 'close') {
            button.parent().parent().find('.wrong-block').addClass('show');
            button.attr('data-open', 'open');
            button.html('Скрыть');
          } else {
            button.parent().parent().find('.wrong-block').removeClass('show');
            button.attr('data-open', 'close');
            button.html('Показать');
          }
        });
      });
    },
    toggleWrongDropdowns() {
      this.$nextTick(() => {
        $('.js-wrong-answer .js-wrong-btn').each(function () {
          $(this).click();
        });
      });
    },
    goToQuestion(index) {
      if (index !== this.currentQuestionIndex) {
        this.currentQuestionIndex = index;

        this.$nextTick(() => {
          this.questionsSlider.toCenter(index);
        });
      }
    },
    getAnsweredQuestionByIndex(index) {
      let answeredQuestion = null;

      for (const question of this.answeredQuestions) {
        if (question.index === index + 1) {
          answeredQuestion = question;
          break;
        }
      }

      return answeredQuestion;
    },
    getFirstUnansweredQuestionIndex() {
      const idsAnsweredQuestions = this.answeredQuestions.map(q => q.question.id);
      const unansweredQuestionIndexesAfterCurrentQuestion = [];

      let firstUnansweredQuestionIndex = null;


      for (const [index, question] of this.questions.entries()) {
        if (!idsAnsweredQuestions.includes(question.id)) {
          if (index > this.currentQuestionIndex) {
            unansweredQuestionIndexesAfterCurrentQuestion.push(index);
          }

          if (firstUnansweredQuestionIndex === null) {
              firstUnansweredQuestionIndex = index;
          }
        }
      }

      return unansweredQuestionIndexesAfterCurrentQuestion.length <= 0
        ? firstUnansweredQuestionIndex
        : unansweredQuestionIndexesAfterCurrentQuestion[0];
    },
    getAnswerOnCurrentQuestion() {
      return this.getAnsweredQuestionByIndex(this.currentQuestionIndex);
    },
  },
};
